// Explain a replacement only after a stale variant link has loaded its native page.
(() => {
  let entry;
  try {
    entry = JSON.parse(window.sessionStorage.getItem('jym-in-stock-entry') || 'null');
    window.sessionStorage.removeItem('jym-in-stock-entry');
  } catch (_) { return; }
  if (!entry || entry.path !== window.location.pathname) return;
  const picker = document.querySelector('.shopify-section--main-product variant-picker');
  const selected = picker?.querySelector('script[data-variant]');
  if (!selected || String(JSON.parse(selected.textContent)?.id) !== entry.id) return;
  const info = picker.closest('.product-info');
  if (!info) return;
  const notice = document.createElement('p');
  notice.className = 'text-sm text-subdued';
  notice.setAttribute('role', 'status');
  notice.textContent = `The linked option is out of stock. Showing ${entry.title}.`;
  info.prepend(notice);
})();
